import { RING_CATEGORY_COLORS, type RingCategory } from '@liza/ui/utils/ringCategories';
import { CircleDot, HeartPulse, ListTodo, NotebookPen, PillBottle, type LucideIcon } from 'lucide-react';

/** The sections a care-plan topic divides into — the board's headings, and the table's columns. */
export type CarePlanSection = 'results' | 'medications' | 'lifestyle' | 'tasks' | 'thoughts';

/** One icon per section, so the board's headings and the table's column headers name a section alike. */
export const CARE_PLAN_SECTION_ICONS: Record<CarePlanSection, LucideIcon> = {
  results: CircleDot,
  medications: PillBottle,
  lifestyle: HeartPulse,
  tasks: ListTodo,
  thoughts: NotebookPen,
};

/**
 * The day-view ring segment each section belongs to, which is where its colour comes from. Thoughts is
 * the topic's own note rather than a kind of item, so it has no segment and takes no colour.
 */
const SECTION_RING_CATEGORIES: Partial<Record<CarePlanSection, RingCategory>> = {
  results: 'measurement',
  medications: 'medication',
  lifestyle: 'lifestyle',
  tasks: 'task',
};

/** A section's colour, or undefined where it has no ring segment to take one from. */
export function carePlanSectionColor(section: CarePlanSection): string | undefined {
  const ring = SECTION_RING_CATEGORIES[section];
  return ring ? RING_CATEGORY_COLORS[ring] : undefined;
}
